import { render, staticRenderFns } from "./StudentLightCourseLessonRoom.vue?vue&type=template&id=a8bd8b80&scoped=true&"
import script from "./StudentLightCourseLessonRoom.vue?vue&type=script&lang=js&"
export * from "./StudentLightCourseLessonRoom.vue?vue&type=script&lang=js&"
import style0 from "./StudentLightCourseLessonRoom.vue?vue&type=style&index=0&id=a8bd8b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bd8b80",
  null
  
)

export default component.exports